import React from "react";
import "./about.css";
import ME from "../../assets/pic-me.jpg";
// import ME from "../../assets/me-about.jpg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience - React</h5>
              <small>1+ Years of Practice</small>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>1+ Nepal for HTML CSS</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Peronal Projects</h5>
              <small>10+ completed</small>
            </article>
          </div>
          <p>
            Hello! I'm Aman Dhungel, dedicated and versatile full stack
            developer mostly focused on front-end with a passion for
            crafting seamless digital experiences. With a good foundation in both
            front-end and back-end
            technologies. My ability to adapt to new challenges and collaborate
            within cross-functional
            teams allows me to deliver innovative solutions that drive user
            engagement and business
            growth.

          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
